import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-team-development-calendar',
  templateUrl: './team-development-calendar.component.html',
  styleUrls: ['./team-development-calendar.component.css']
})
export class TeamDevelopmentCalendarComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/team-development-calendar/team-development-calendar.component.ts